export const securityMeilisearchSearchKeyKeys = {
  all: ["security-meilisearch-search-key"] as const,
  details: () => [...securityMeilisearchSearchKeyKeys.all, "detail"] as const,
  detail: (directoryToken: string) =>
    [...securityMeilisearchSearchKeyKeys.details(), directoryToken] as const,
};
